/* eslint-disable jsx-a11y/label-has-associated-control */
// import axios from 'axios';
import React, { useState } from 'react';

function MonitoringActivities() {
  const [monitoringActivities, setMonitoringActivities] = useState({
    safety: '',
    risk: '',
    requirement: '',
    dom: '',
  });
  // const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    e.preventDefault();
    // setErrorMessage('');
    setMonitoringActivities({
      ...monitoringActivities,
      [e.target.name]: e.target.value,
    });
  };
  // formulae 1
  // async function handleSubmit(event) {
  //   event.preventDefault();
  //   console.log(errorMessage);
  //   console.log(monitoringActivities);

  //   try {
  //     const response = await axios.post('https://api.github.com/users', monitoringActivities);
  //     console.log(response);
  //   } catch (error) {
  //     console.log(error);
  //     setErrorMessage(error);
  //   }
  // }
  // formulae 2
  // function handleSubmit(event) {
  //   event.preventDefault();
  //   console.log(errorMessage);
  //   console.log(monitoringActivities);

  //   axios.post('https://api.github.com/users', monitoringActivities)
  //     .then((response) => {
  //       console.log(response);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setErrorMessage(error.data.error);
  //     });
  // }

  return (
    <div className=" flex flex-col items-center w-full">
      <form className=" w-full xl:px-24 md:px-4">
        {/* <form onSubmit={handleSubmit} className=" w-full xl:px-24 md:px-4"> */}
        <div className="flex flex-wrap mx-3 xl:mb-8 md:mb-6 mb-3">
          <div className="w-full px-3 lg:mb-6">
            <label
              htmlFor="Monitoring"
              className="block font-medium text-sm text-gray-700"
            >
              Monitoring Activity
              <span className="text-red-500">*</span>
            </label>

            <input
              className="mt-1 w-3/4 border-gray-400 focus:border-indigo-500 focus:ring-indigo-500 rounded-sm shadow-sm"
              type="text"
              placeholder="Enter Safety Monitoring"
              name="safety"
              onChange={handleChange}
            />
            <label
              htmlFor="Requirement"
              className="block font-medium text-sm text-gray-700"
            >
              Requirement
              <span className="text-red-500">*</span>
            </label>

            <input
              className="mt-1 w-3/4 border-gray-400 focus:border-indigo-500 focus:ring-indigo-500 rounded-sm shadow-sm"
              type="text"
              placeholder="Enter Requirement"
              name="requirement"
              onChange={handleChange}
            />
            <label
              htmlFor="Residual Risk"
              className="block font-medium text-sm text-gray-700"
            >
              Residual Risk
              <span className="text-red-500">*</span>
            </label>
            <input
              className="mt-1 w-3/4 border-gray-400 focus:border-indigo-500 focus:ring-indigo-500 rounded-sm shadow-sm"
              type="text"
              placeholder="Enter Residual Risk"
              name="risk"
              onChange={handleChange}
            />
            <label
              htmlFor="Dateofimplementaion"
              className="block font-medium text-sm text-gray-700"
            >
              Date
              <span className="text-red-500">*</span>
            </label>

            <div>
              <input
                className="mt-1 w-3/4 border-gray-400 focus:border-indigo-500 focus:ring-indigo-500 rounded-sm shadow-sm"
                type="date"
                name="dom"
                onChange={handleChange}
              />
              <button className="mt-2 text-red-900 float-right bg-blue-400 rounded-md py-2 px-4" type="submit">Save</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default MonitoringActivities;
